<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.5 17.5">
    <g data-name="1/2" transform="translate(.75 .75)" stroke="currentColor" stroke-width="1.5">
      <circle data-name="Ellipse 24" cx="8" cy="8" r="8" fill="#fff"/>
      <path data-name="Ellipse 26" d="M8 16A8 8 0 1 0 8 0v16Z" fill="currentColor"/>
    </g>
  </svg>
</template>
